import * as api from './api'
import { localStorage } from '@entrata/utils'

export default { ...api, local: localStorage }
